import iconPalette from '@/assets/images/icons/icon-palette.png';
import { anton } from '@/lib/font';
import clsx from 'clsx';
import styles from './PageHeader.module.scss';

function PageHeader({
  text,
  textBold = false,
  level = 1,
  size = 'default',
  sizeSp = 'default',
  sideCount = 0,
  showIcon = true,
  sideText = '',
  direction = 'left',
  testId,
}: {
  text: React.ReactNode;
  textBold?: boolean;
  level?: 1 | 2;
  size?: 'default' | 'xSmall' | 'semiSmall' | 'small' | 'medium' | 'semiMedium' | 'mediumLarge';
  sizeSp?: 'default' | 'xSmall' | 'semiSmall' | 'small' | 'medium' | 'semiMedium' | 'mediumLarge';
  sideCount?: number;
  showIcon?: boolean;
  sideText?: string;
  direction?: 'left' | 'right';
  testId?: string;
}) {
  const HTag = `h${level}` as const;
  const showSideText = sideCount > 0 && sideText;
  const dataTestId = testId || 'page-header';

  const componentClasses = [styles.componentStyle, styles[`${size}ComponentStyle`]].filter(Boolean).join(' ');

  return (
    <div className={componentClasses}>
      <div className={styles.titleContainer}>
        {showIcon && (
          <img
            src={iconPalette.src}
            alt='icon'
            className={`${styles.iconCommon} ${styles[`${size}Icon`]}
          ${direction === 'left' ? styles[`${size}LeftIcon`] : styles[`${size}RightIcon`]}`}
          />
        )}
        <HTag
          className={clsx(styles.title, anton.className, styles[size], styles[sizeSp], textBold && styles.textBold)}
          data-testid={dataTestId}
        >
          {text}
        </HTag>
      </div>
      {showSideText && (
        <div className={styles.sideTextContainer}>
          <span className={styles.sideCount}>{sideCount}</span>
          <span className={styles.sideText}>{sideText}</span>
        </div>
      )}
    </div>
  );
}

export default PageHeader;
